export default __webpack_public_path__ + "static/media/i18.21db6660.svg";